const donateLinkByLocale = {
  en: 'https://giving.classy.org/campaign/673245/donate',
  pt: '/pt/doacao',
  es: '/es/dona',
} as const;

export function getDonateRoutePath<T extends UserLocale>(locale: T) {
  return donateLinkByLocale[locale];
}
